import { FC, useEffect, useState } from 'react';
import { Typography } from 'antd';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Pagination from '@/common/components/Data/V2Pagination';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { getSpotSurveySimplePage } from '@/common/api/expandStore/spotSurvey';
import { noImgSrc } from '@/common/utils/ways';
import styles from './index.module.less';
import SpotSurveyDetailDrawer from '@/views/expandstore/pages/spotsurveydetail/Drawer';

export interface SpotSurveyListProps {
  detail;
  isShare?: boolean;
}

/**
 * @Description 商圈详情-踩点记录列表
 */
const SpotSurveyList: FC<SpotSurveyListProps> = ({ detail, isShare = false }) => {

  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(3);
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [detailDrawerData, setDetailDrawerData] = useState<any>({
    open: false,
    id: null,
  });

  useEffect(() => {
    if (detail?.id && !isShare) methods.loadData({});
  }, [detail?.id]);

  const methods = useMethods({
    // 分页相关
    handlePageChange: (page: number, size: number) => {
      setCurrentPage(page);
      setPageSize(size);
      methods.loadData({ page, pageSize: size });
    },

    async loadData(params) {
      if (!detail?.id) return;
      if (isShare) return;
      const _params: any = {
        page: params?.page || currentPage,
        size: params?.pageSize || pageSize,
        modelClusterIds: [detail.id],
      };

      setLoading(true);
      try {
        const res: any = await getSpotSurveySimplePage(_params);
        const { objectList, totalNum } = res || {};
        setTotalNum(totalNum || 0);
        setList(isArray(objectList) ? objectList : []);
      } finally {
        setLoading(false);
      }
    },

    onClickItem(record: any) {
      setDetailDrawerData({
        open: true,
        id: record?.id,
      });
    },
  });

  return (
    <>
      {totalNum > 0 ? (
        <div className={styles.spotSurveyList}>
          <V2Title divider type='H2' text={`踩点记录(${totalNum})`} />
          {list.map((item) => (
            <div
              key={item.id}
              className={styles.recordItem}
              onClick={() => methods.onClickItem(item)}
            >
              <div className={styles.imgCon}>
                <img
                  src={item?.lastPicture || noImgSrc}
                  alt=''
                />
              </div>
              <div className={styles.contentCon}>
                <div className={styles.time}>{item?.createdAt || '-'}</div>
                <div className={styles.addressRow}>
                  <Typography.Text
                    className={styles.address}
                    ellipsis={{ tooltip: item?.address || '-' }}
                  >
                    {item?.address || '-'}
                  </Typography.Text>
                </div>
              </div>
            </div>
          ))}
          {totalNum > pageSize ? (
            <V2Pagination
              simple
              disabled={loading}
              current={currentPage}
              total={totalNum}
              onChange={methods.handlePageChange}
              pageSize={pageSize}
            />
          ) : null}
        </div>
      ) : null}

      {/* 踩点记录详情抽屉 */}
      <SpotSurveyDetailDrawer
        drawerData={detailDrawerData}
        onClose={() => setDetailDrawerData({ open: false, id: null })}
      />
    </>
  );
};

export default SpotSurveyList;

